export enum TenantApiUrls {
    GetTenantbyId = "/api/Tenant/GetTenantbyId",
    GetFeatureConfigurations = "/api/Tenant/GetFeatureConfigurations" 
}
